import { __makeTemplateObject, __spreadArray } from '../node_modules/tslib/tslib.es6.js';
import { useState, useEffect } from 'react';
import { css } from 'styled-components';

var mediaQuery = function (queryTemplate) {
    var queryRest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        queryRest[_i - 1] = arguments[_i];
    }
    return function (rulesTemplate) {
        var rulesRest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rulesRest[_i - 1] = arguments[_i];
        }
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media ", " {\n      ", "\n    }\n  "], ["\n    @media ", " {\n      ", "\n    }\n  "])), css.apply(void 0, __spreadArray([queryTemplate], queryRest, false)), css.apply(void 0, __spreadArray([rulesTemplate], rulesRest, false)));
    };
};
var sizes = {
    tablet: 768,
    desktop: 992,
    largeDesktop: 1281,
    extraLargeDesktop: 1536,
    giant: 1920,
};
var queryStrings = {
    handheld: "(max-width: ".concat((sizes.tablet - 1) / 16, "em)"),
    tablet: "(min-width: ".concat(sizes.tablet / 16, "em)"),
    tabletOnly: "(min-width: ".concat(sizes.tablet / 16, "em) and (max-width: ").concat((sizes.desktop - 1) / 16, "em)"),
    mobile: "(max-width: ".concat((sizes.desktop - 1) / 16, "em)"),
    desktop: "(min-width: ".concat(sizes.desktop / 16, "em)"),
    largeDesktop: "(min-width: ".concat(sizes.largeDesktop / 16, "em)"),
    extraLargeDesktop: "(min-width: ".concat(sizes.extraLargeDesktop / 16, "em)"),
    giant: "(min-width: ".concat(sizes.giant / 16, "em)"),
    print: 'print',
};
var media = {
    handheld: mediaQuery(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.handheld),
    tablet: mediaQuery(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.tablet),
    tabletOnly: mediaQuery(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.tabletOnly),
    mobile: mediaQuery(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.mobile),
    desktop: mediaQuery(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.desktop),
    largeDesktop: mediaQuery(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.largeDesktop),
    extraLargeDesktop: mediaQuery(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.extraLargeDesktop),
    giant: mediaQuery(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.giant),
    print: mediaQuery(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), queryStrings.print),
    minWidth: function (pxValue) { return mediaQuery(templateObject_11 || (templateObject_11 = __makeTemplateObject(["(min-width: ", "em)"], ["(min-width: ", "em)"])), pxValue / 16); },
};
var useMedia = function (query) {
    var matchQuery = window && window.matchMedia(query);
    var _a = useState(matchQuery.matches), isMatch = _a[0], setIsMatch = _a[1];
    useEffect(function () {
        var handler = function () { return setIsMatch(matchQuery.matches); };
        matchQuery.addListener(handler);
        return function () { return matchQuery.removeListener(handler); };
    }, [query, matchQuery]);
    return isMatch;
};
var useMobileMedia = function () { return useMedia("".concat(queryStrings.mobile)); };
var useTabletMedia = function () { return useMedia("".concat(queryStrings.tablet)); };
var useDesktopMedia = function () { return useMedia("".concat(queryStrings.desktop)); };
var useLargeDesktopMedia = function () { return useMedia("".concat(queryStrings.largeDesktop)); };
var useGiantMedia = function () { return useMedia("".concat(queryStrings.giant)); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

export { media, useDesktopMedia, useGiantMedia, useLargeDesktopMedia, useMedia, useMobileMedia, useTabletMedia };
//# sourceMappingURL=MediaQuery.js.map
